"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleLocator = void 0;
var lodash_1 = require("lodash");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var registries_1 = require("./registries");
var epicRegistry_1 = require("./epicRegistry");
var ModuleManager = /** @class */ (function () {
    function ModuleManager() {
        this.subject$ = new BehaviorSubject_1.BehaviorSubject(new Map());
    }
    ModuleManager.prototype.set = function (key, baseExport) {
        var modules = this.subject$.getValue();
        if (modules.get(key))
            return;
        var module = baseExport.default;
        var reducer = module.reducer, middleware = module.middleware, epics = module.epics;
        if (reducer) {
            registries_1.reducerRegistry.register("" + key, reducer);
        }
        if (middleware) {
            registries_1.middlewareRegistry.register(key + "Middleware", middleware());
        }
        if (epics) {
            lodash_1.forEach(epics, function (epic) { return epicRegistry_1.registerEpic(epic); });
        }
        this.subject$.next(modules.set(key, module));
    };
    ModuleManager.prototype.get = function (key) {
        return this.subject$
            .filter(function (modules) { return modules.has(key); })
            .map(function (modules) { return modules.get(key); });
    };
    ModuleManager.prototype.getImmediately = function (moduleName) {
        var modules = this.subject$.getValue().get(moduleName);
        return modules || null;
    };
    return ModuleManager;
}());
exports.default = ModuleManager;
exports.moduleLocator = new ModuleManager();
//# sourceMappingURL=ModuleManager.js.map